import { format } from "date-fns";
import { Test } from "../../types/healthcare/TestTypes";

export function getTestDisplayLabel(test: Test): string {
  if (test.custom_test_packages?.length) {
    return test.custom_test_packages.map((p) => p.name).join(", ");
  }
  if (test.test_name) return test.test_name;
  if (test.test_category) {
    return `${test.test_category}`;
  }
  return test.reason || "Test Order";
}

export function getTestDisplayDate(test: Test): { date: string; label: string } {
  if (test.completed_date) {
    return { date: format(new Date(test.completed_date), "MMM dd, yyyy"), label: "Completed" };
  }
  if (test.scheduled_date) {
    return { date: format(new Date(test.scheduled_date), "MMM dd, yyyy"), label: "Scheduled" };
  }
  if (test.created_at) {
    return { date: format(new Date(test.created_at), "MMM dd, yyyy"), label: "Ordered" };
  }
  return { date: "—", label: "" };
}

export function hasAbnormalResults(test: Test): boolean {
  return test.test_results?.some((r) => r.is_abnormal) ?? false;
}

export function countAbnormalResults(test: Test): number {
  return test.test_results?.filter((r) => r.is_abnormal).length ?? 0;
}
